import { NICmsContentComponent } from '@icms/core/content';
import { ICmsComponentCwvConfig } from '../../../catalog/config/component.config';

export namespace NCmsComponentCarousel {
    export const ID = 'carousel';
    
    export interface IData extends NICmsContentComponent.IData {
        slides: ISlide[];
        autoplay: boolean;
        interval: number;
        loop: boolean;
        pagination: boolean;
        arrows: boolean;
        progress: boolean;
        ratio: string;
    }

    export interface ISlide extends ICmsComponentCwvConfig {
        custom: boolean;
        image: string;
        components: NICmsContentComponent.IData[];
    }
}
